import React from 'react'

const SVG = ({
  style = {},
  viewBox = '0 0 100 100',
  width = '100',
  height = '100',
  className = '',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox}
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...rest}
  >
    <defs><clipPath><rect width="100" height="100"/></clipPath></defs><g><path d="M100,42H58V0H42V42H0V58H42v42H58V58h42Z"/></g>
  </svg>
)
export default SVG
